import { useEffect, useState } from "react";
import { api } from "../lib/api";

const PAGE_SIZE = 10;

export default function WaitlistPage() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [dataPage, setDataPage] = useState(1);

  useEffect(() => {
    const load = async () => {
      try {
        const r = await api.get("/waitlist");

        setData(r.data.items || []);
        setTotalCount(r.data.count || 0);
      } catch (err) {
        console.error(err);
        setData([]);
        setTotalCount(0);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const totalPages = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));

  const paginateddata = data.slice(
    (dataPage - 1) * PAGE_SIZE,
    dataPage * PAGE_SIZE
  );

  if (loading) {
    return (
      <div className="p-8 text-[#64748B]">
        Loading waitlist...
      </div>
    );
  }

  return (
    <div className="p-8 lg:p-12">
      <div className="type-eyebrow text-[#64748B]">
        Waitlist
      </div>

      <h1 className="type-h1 text-[#0F1F3D] mt-3">
        Waitlist Members
      </h1>

      <div className="mt-8 bg-white border border-[#E2E8F0] rounded-lg overflow-hidden">
        <table className="w-full">
          <thead className="bg-[#F8F9FA]">
            <tr className="text-left text-xs uppercase tracking-wide text-[#64748B]">
              <th className="px-6 py-4">Full Name</th>
              <th className="px-6 py-4">Email</th>
              <th className="px-6 py-4">Organisation</th>
              <th className="px-6 py-4">Status</th>
              <th className="px-6 py-4">Active</th>
              <th className="px-6 py-4">Joined</th>
            </tr>
          </thead>

          <tbody>
            {paginateddata.length === 0 ? (
              <tr>
                <td
                  colSpan={6}
                  className="px-6 py-12 text-center text-[#94A3B8]"
                >
                  No waitlist entries found.
                </td>
              </tr>
            ) : (
              paginateddata.map((item) => (
                <tr
                  key={item.id}
                  className="border-t border-[#E2E8F0] hover:bg-[#F8FAFC]"
                >
                  <td className="px-6 py-4">{item.full_name}</td>

                  <td className="px-6 py-4">{item.email}</td>

                  <td className="px-6 py-4">{item.org_name}</td>

                  <td className="px-6 py-4">
                    <span
                      className={`inline-flex rounded-full px-2 py-1 text-xs font-medium ${
                        item.status === "waiting"
                          ? "bg-amber-100 text-amber-700"
                          : "bg-green-100 text-green-700"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td className="px-6 py-4">
                    <span
                      className={`font-medium ${
                        item.is_active
                          ? "text-green-600"
                          : "text-red-500"
                      }`}
                    >
                      {item.is_active ? "Active" : "Inactive"}
                    </span>
                  </td>

                  <td className="px-6 py-4 text-[#64748B]">
                    {new Date(item.created_at).toLocaleDateString(
                      "en-GB",
                      {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      }
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {totalCount > PAGE_SIZE && (
          <div className="flex items-center justify-between border-t border-[#E2E8F0] px-6 py-4">
            <span className="text-sm text-[#64748B]">
              Showing {(dataPage - 1) * PAGE_SIZE + 1}–
              {Math.min(dataPage * PAGE_SIZE, totalCount)} of {totalCount}
            </span>

            <div className="flex items-center gap-2">
              <button
                type="button"
                disabled={dataPage === 1}
                onClick={() => setDataPage((p) => Math.max(1, p - 1))}
                className="px-4 py-2 rounded-md border border-[#E2E8F0] disabled:opacity-50"
              >
                Previous
              </button>

              <span className="text-sm text-[#64748B]">
                {dataPage} / {totalPages}
              </span>

              <button
                type="button"
                disabled={dataPage === totalPages}
                onClick={() =>
                  setdataPage((p) => Math.min(totalPages, p + 1))
                }
                className="px-4 py-2 rounded-md border border-[#E2E8F0] disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}